import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const staffUserRoutes: RouteObject[] = [
  {
    path: '/staff-user',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Staff Users',
      crumb: () => ({ label: 'Staff Users', to: '/staff-user' }),
    },
  },
  {
    path: '/staff-user/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Staff User' }) },
  },
];

export default staffUserRoutes;
